import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router'
// import WhiteBox from '../WhiteBox'
import DummyExtent from '../../../../../shared/components/DummyExtent'
// import OtherPriceModal from '../../../../../shared/modals/OtherPriceModal'
import { hasAccess, hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../../utils/auth'
import { translation, enumtranslate } from '../../../../../utils/helpers'
// import { FILE_STORAGE_API } from '../../../../../constants'
// import { renderFullDate } from '../../../../../utils/time'
import { formatCurrency } from '../../../../../utils/currency'
import { triggerPopup, triggerPopupActionBG } from '../../../../../actions/backdrop'
import Extent from '../../../../../shared/components/Extent'

// Elements
import Panel from '../../../../../shared/elements/panel'
// import Check from '../../../../../shared/elements/check'
import Expand from '../../../../../shared/elements/expand'
import Actions from '../../../../../shared/elements/actions'
import Null from '../../../../../shared/elements/null'
import Icon from '../../../../../shared/elements/icon'
import { ElementIcons } from '../../../../../shared/elements/icons'

class OrderExtent extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      // showAgreementPrice: window.localStorage.getItem('showAgreementPrice') === '1',
      otherPopup: {
        show: false,
        other: {
          Title: '',
          Price: '',
          Environment: '',
          Description: ''
        }
      },
      otherPopup2: {
        show: false,
        other: {
          Price: '',
          Environment: ''
        }
      }
    }
    // this.renderCheck = this.renderCheck.bind(this)
    this.renderOrderColumn = this.renderOrderColumn.bind(this)
    this.renderContent = this.renderContent.bind(this)
    this.openOtherPopup = this.openOtherPopup.bind(this)
    this.openOtherPopup2 = this.openOtherPopup2.bind(this)
  }
  // componentDidMount () {
  //   this.setState({
  //     showAgreementPrice: window.localStorage.getItem('showAgreementPrice') === '1'
  //   })
  // }
  componentWillMount () {
  }

  openOtherPopup2 (e) {
    if (e !== false) {
      e.preventDefault()
    }
    this.props.triggerPopup(!this.state.otherPopup2.show)
    this.setState({
      otherPopup2: {
        show: !this.state.otherPopup2.show,
        other: {
          Price: this.props.order.Price,
          Environment: this.props.order.Environment
        }
      }
    })
  }
  renderAdditionalSales (isBodyShop = false) {
    if (this.props.order.OrderType === 4) return null

    if (this.props.auth.departmentType === 1 && !isBodyShop && !this.props.auth.hasPartner) return null
    let isReferredIn = this.props.order.IsReferredIn
    let isAssessmentOk = this.props.order.IsAssessmentOk
    if (isReferredIn) {
      if (this.props.order.OrderConnection !== undefined && this.props.order.OrderConnection !== null && this.props.order.OrderConnection.IsApproved) {
        isReferredIn = false
      }
    }
    let addonPriceComment = this.props.order.AddonPriceComment !== null ? this.props.order.AddonPriceComment : ''
    if (this.props.order.IsDummy) {
      addonPriceComment = 'Pris'
    }

    let showEditLink = hasSubscriptionPermission(this.props.auth, 0, 2)

    let addedPrice = <Extent
      order={this.props.order}
      department={isBodyShop ? 1 : 0}
      // showAgreementPrice={this.state.showAgreementPrice}
      extents={[{type: 'addon', editable: false, showEditLink: showEditLink, noTitle: true}]}
      />

    let extentLink = isBodyShop ? '/bodyaddon' : '/2'
    let subTitleImage = '/images/svgs/taksering/Additional-sales-new.svg'
    let hasExtentAddon = this.props.order.HasExtentAddon // HasExtentBodyShopAddon
    let hasExtentBodyShopAddon = this.props.order.HasExtentBodyShopAddon
    let hasPaintAddon = hasExtentAddon || (this.props.order.AddonPrice !== 0 && this.props.order.AddonPrice !== null) || (this.props.order.AddonEnvironment !== 0 && this.props.order.AddonEnvironment !== null)
    let hasBodyAddon = hasExtentBodyShopAddon || (this.props.order.BodyShopAddonPrice !== 0 && this.props.order.BodyShopAddonPrice !== null) || (this.props.order.BodyShopAddonEnvironment !== 0 && this.props.order.BodyShopAddonEnvironment !== null)
    let expandAddon = !isBodyShop ? hasPaintAddon : hasBodyAddon

    /* if (isBodyShop) {
      hasExtentAddon = this.props.order.HasExtentBodyShopAddon
      isAssessmentOk = this.props.order.IsBodyShopAssessmentOk
    } */
    let hasPermission = true
    // console.log('partner', this.props.auth.hasPartner, 'departmentType', this.props.auth.departmentType === 1, 'paint extent', !isBodyShop)
    if (this.props.auth.hasPartner && this.props.auth.departmentType === 1 && !isBodyShop) {  // bodyshop with paint partner, viewing paint extent.
      hasPermission = hasPartnerSubscriptionPermission(this.props.auth, 30)
    } else {
      hasPermission = hasSubscriptionPermission(this.props.auth, 30)
    }

    if (hasExtentAddon === false && !hasPermission) return null
    let deniedCustomerEdit = ((hasAccess([4], this.props.auth.user.UserType) || hasAccess([3, 5, 7], this.props.auth.user.UserType) && this.props.auth.user.DepartmentType === 1) && this.props.order.IsDraft !== true && !isBodyShop)
    let canEdit = !isAssessmentOk && !isReferredIn && !deniedCustomerEdit && hasPermission && hasSubscriptionPermission(this.props.auth, 0, 2)
    return (
      <div className='additional_sales_box'>
        {!hasAccess([6], this.props.auth.user.UserType) && (
          <Expand title={translation('1396')} defaultOpen={expandAddon}>
            <Actions>
              <Link to={canEdit ? '/pricecalculation/' + this.props.order.Id + extentLink : ''} key='1'>
                {canEdit && <Icon icon={ElementIcons.Edit} size='t' ariaText={translation('34') + ' ' + translation('1396')} />}
              </Link>
            </Actions>
            {this.props.order.HasAwaitingAddon && (
              <div className='forsi_diff'>{translation('17840')}</div>
            )}
            {addedPrice}
            <Null>
              <div>
                <Link to={canEdit ? '/pricecalculation/' + this.props.order.Id + extentLink : ''}>
                  {subTitleImage.length > 0 && (<img className='subtitle_image' src={subTitleImage} />)}
                  <div className='subtitle'>{translation('1396')} {!isAssessmentOk && !isReferredIn && !deniedCustomerEdit && hasPermission && showEditLink && (<div className='icon hint--top' aria-label={translation('34') + ' ' + translation('1396')}><img src='/images/icons/edit_16.png' /></div>)}</div>
                </Link>
                {hasExtentAddon && addedPrice}
                {this.props.order.OrderExtent !== null && this.props.order.AddonPrice > 0 && (<span>{addonPriceComment}: {formatCurrency(isBodyShop ? this.props.order.BodyShopAddonPrice : this.props.order.AddonPrice || 0)}</span>)}
              </div>
            </Null>
          </Expand>
        )}
        {hasAccess([6], this.props.auth.user.UserType) && (
          <Expand title={translation('1396')} defaultOpen>
            {this.props.order.HasAwaitingAddon && (
              <div className='forsi_diff'>{translation('17840')}</div>
            )}
            {this.props.order.HasExtentAddon && addedPrice}
            {this.props.order.OrderExtent !== null && this.props.order.AddonPrice > 0 && (<span>{addonPriceComment}: {formatCurrency(isBodyShop ? this.props.order.BodyShopAddonPrice : this.props.order.AddonPrice || 0)}</span>)}
          </Expand>
        )}
      </div>
    )
  }
  openOtherPopup () {
    if (this.props.auth.user.CustomerId === '-1' || (this.props.auth.user.CustomerId !== '-1' && this.props.order.IsDraft)) {
      this.props.triggerPopup(!this.state.otherPopup.show)
      this.setState({
        otherPopup: {
          show: !this.state.otherPopup.show,
          other: {
            Title: this.props.order.OtherTitle,
            Description: this.props.order.OtherDescription,
            Price: this.props.order.Price,
            Environment: this.props.order.Environment
          }
        }
      }, console.log(this.state, this.props.order))
    }
  }
  renderPriceCalculation (isBodyShop = false, editDenied = false) {
    let { OrderType } = this.props.order
    let orderExtent = this.props.order.OrderExtent
    let extentLines = []
    if (orderExtent !== null && orderExtent !== '') {
      extentLines = this.props.order.OrderExtent.split('<br />')
    }

    const renderLine = (val, key) => {
      return (
        <p key={'extentLine_' + key}>{val}</p>
      )
    }

    // Other
    // console.log('OrderType', OrderType)
    if (OrderType === 4) {
      return (
        <div>
          <Extent
            order={this.props.order}
            department={isBodyShop ? 1 : 0}
            extents={[{type: 'base', editable: false, showEditLink: true}]}
          />
        </div>
      )
    }

    let isReferredIn = this.props.order.IsReferredIn
    if (isReferredIn) {
      if (this.props.order.OrderConnection !== undefined && this.props.order.OrderConnection !== null && this.props.order.OrderConnection.IsApproved) {
        isReferredIn = false
      }
    }
    let afterEvaluation = this.props.order.SelectedEvaluationType === 4
    let selectedAfterEvaluation = afterEvaluation

    let pric = <Extent
      order={this.props.order}
      department={isBodyShop ? 1 : 0}
      // showAgreementPrice={this.state.showAgreementPrice}
      extents={[{type: 'base', editable: false, showEditLink: true, noTitle: false, useSelectedEvaluation: !isBodyShop, getOnly: false}]}
      />

    let hasExtent = this.props.order.HasExtent
    if (isBodyShop) {
      hasExtent = this.props.order.HasExtentBodyShop
    }

    return (
      <div className={'extent_box clearfix'}>
        {!hasAccess([6], this.props.auth.user.UserType) && isBodyShop === true && (
          <div>
            {(hasExtent || (selectedAfterEvaluation && this.props.order.OrderType === 1)) && pric}
            {extentLines !== null && extentLines.length > 0 && (
              <div className='OldOrderExtent'>
                {extentLines.map(renderLine)}
                <br />
              </div>
            )}
          </div>
        )}
        {!hasAccess([6], this.props.auth.user.UserType) && isBodyShop === false && (
          <div>
            {this.props.order.HasAwaiting && (
              <div className='forsi_diff'>{translation('2729')}</div>
            )}
            {pric}
            {extentLines !== null && extentLines.length > 0 && (
              <div className='OldOrderExtent'>
                {extentLines.map(renderLine)}
                <br />
              </div>
            )}
          </div>
        )}

        {hasAccess([6], this.props.auth.user.UserType) && (
          <div>
            {this.props.order.HasAwaiting && (
              <div className='forsi_diff'>{translation('2729')}</div>
            )}
            {pric}
          </div>
        )}
      </div>
    )
  }

  renderPreviousOrder (isBodyShop = false) {
    // Prices of previous order should not be shown, only extent/tasks.
    if (this.props.order.OrderType !== 5) return null
    if (this.props.order.PreviousOrder === null || this.props.order.PreviousOrder === 0) return null

    return (
      <div className='additional_sales_box'>
        <div className='subtitle'>{translation('13409')}<a target='_blank' href={'/orders/' + this.props.order.PreviousOrder}>({this.props.order.PreviousOrder})</a></div>
        <div className='previous_order_msg'>{translation('15334')}</div>
      </div>
    )
  }
  renderOrderColumn ($type = 'box', $department = '', hideContent = false, editAllowed = true) {
    let orderType = enumtranslate('OrderTypes', this.props.order.OrderType)
    let orderExtent = this.props.order.OrderExtent
    let extentLines = []
    if (orderExtent !== null && orderExtent !== '') extentLines = this.props.order.OrderExtent.split('\n')
    let department = $department === 'body' ? 1 : 0
    let showEditLink = hasSubscriptionPermission(this.props.auth, 10, 2) && !this.props.order.IsAssessmentOk
    let extent = <Extent
      order={this.props.order}
      department={department}
      extents={[{type: 'base', editable: false, showEditLink: showEditLink, noTitle: false, useSelectedEvaluation: !department === 1, getOnly: false}]}
    />

    if (hasAccess([6], this.props.auth.user.UserType) && this.props.order.IsDummy) {
      return (
        <div className='hover_extent-popup'>
          <div className='extent_box clearfix'>
            <div className='' data-col='order'>
              <div className='title'>{translation(orderType)} <span>({this.props.order.Id})</span></div>
              <DummyExtent item={this.props.order} />
            </div>
          </div>
        </div>
      )
    }
    let evaluationTypes = [1, 2, 3, 4, 5, 6, 7]
    if ($type === 'data') {
      return (
        <div data-col='order'>
          {this.renderPreviousOrder(department === 1)}
          {hideContent === false && evaluationTypes.indexOf(this.props.order.SelectedEvaluationType) > -1 && (
            this.renderPriceCalculation(false, editAllowed)
          )}
          {hasAccess([6], this.props.auth.user.UserType) && extentLines !== null && extentLines.length > 0 && (
            <div className='OldOrderExtent'>
              {extent}
              <br />
            </div>
          )}
          {this.renderAdditionalSales()}
        </div>
      )
    } else {
      if ($department === '') {
        return (
          <div data-col='order'>
            {this.renderPreviousOrder(department === 1)}
            {hideContent === false && evaluationTypes.indexOf(this.props.order.SelectedEvaluationType) > -1 && (
              this.renderPriceCalculation(false, editAllowed)
            )}
            {hasAccess([6], this.props.auth.user.UserType) && extentLines !== null && extentLines.length > 0 && (
              <div className='OldOrderExtent'>
                {extent}
                <br />
              </div>
            )}
            {this.renderAdditionalSales()}
          </div>
        )
      } else { // body shop extent
        return (
          <div data-col='bodyshoporder' className='extent_box'>
            {this.renderPreviousOrder(true)}
            {hideContent === false && evaluationTypes.indexOf(this.props.order.SelectedEvaluationType) > -1 && (extent)}
            {this.renderAdditionalSales(true)}
          </div>
        )
      }
    }
  }
  renderContent () {
    if (this.props.order.length === 0) return null
    return this.renderOrderColumn(this.props.type, this.props.department, this.props.hideContent, this.props.editAllowed)
  }
  render () {
    let orderType = enumtranslate('OrderTypes', this.props.order.OrderType)
    if (!this.props.whitebox) {
      return this.renderContent()
    }
    return (
      <Panel title={translation(orderType) + ' · ' + this.props.order.Id} dataCol={this.props.datacol}>
        {this.renderContent()}
      </Panel>
    )
  }
}

OrderExtent.defaultProps = {
  datacol: '',
  type: 'box',
  department: '',
  hideContent: false,
  editAllowed: true,
  whitebox: true
}

OrderExtent.propTypes = {
  whitebox: PropTypes.bool.isRequired,
  onUpdateOrder: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  department: PropTypes.string.isRequired,
  hideContent: PropTypes.bool.isRequired,
  editAllowed: PropTypes.bool.isRequired,
  order: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
}

OrderExtent.contextTypes = {
  router: PropTypes.object.isRequired
  // enum: React.PropTypes.func.isRequired,
  // t: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    orderTypes: state.common.enums.orderTypes,
    order: state.orders.order,
    auth: state.auth,
    currencyCode: state.common.currencyCode
  }
}

export default connect(mapStateToProps, {
  triggerPopup, triggerPopupActionBG
})(OrderExtent)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/OrderExtent/index.js